<template>
  <ItemRow
    v-bind="$attrs"
    :class="$style.row"
    v-on="$listeners"
  >
    <template #content>
      <ItemWithLabel
        :class="[$style.columnWrap]"
        :column="columns[0]"
        data-test-id="PolicyGroupTemplateManageItemRow_Name"
        :title="itemData.name"
      >
        <span>{{ itemData.name }}</span>
      </ItemWithLabel>
      <ItemWithLabel
        :class="[$style.columnWrap]"
        :column="columns[1]"
        data-test-id="PolicyGroupTemplateManageItemRow_Description"
        :hasMargin="false"
        :title="itemData.description"
      >
        {{ itemData.description }}
      </ItemWithLabel>
      <ItemWithLabel
        :column="columns[2]"
      >
        <ButtonSecondary
          :class="$style.space"
          data-test-id="PolicyGroupTemplateManageItemRow_EditButton"
          :hasOutline="false"
          :isDisabled="false"
          :isLoading="false"
          :isMarketingStyle="false"
          :isMatchText="false"
          text="Edit"
          @click="handleEditTemplate"
        />
        <ButtonSecondary
          :class="$style.space"
          data-test-id="PolicyGroupTemplateManageItemRow_DeleteButton"
          :hasOutline="false"
          :isDisabled="false"
          :isLoading="false"
          :isMarketingStyle="false"
          :isMatchText="false"
          text="Delete"
          type="error"
          @click="openDeleteModal"
        />
      </ItemWithLabel>
    </template>
  </ItemRow>
</template>

<script>
import {
  ButtonSecondary,
  ItemRow,
  ItemWithLabel,
} from '@jumpcloud/ui-components';

export default {
  name: 'PolicyGroupTemplateManageItemRow',

  components: {
    ButtonSecondary,
    ItemRow,
    ItemWithLabel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },

    itemData: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      isCreateButtonDisabled: false,
    };
  },

  methods: {
    handleEditTemplate() {}, // This method will be configured in MSP-1369
    openDeleteModal() {}, // This method will be configured in MSP-1370
  },
};
</script>

  <style module scoped>

.columnWrap {
  margin-bottom: var(--jc-spacer);
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row {
  grid-template:
    'col1 col1' auto
    'col2 col2' auto
    'col3 .' auto
    'col4 col5' auto
    'col6 .' auto /
    1fr 1fr;
  padding: 0 var(--jc-spacer-small);
}

.row:not(:last-child) {
  border-bottom: var(--list-border) !important;
}

.space {
  margin-right: var(--jc-spacer-small);
}
  </style>
